import { observer } from "mobx-react";
import React from "react";

import { useTranslation } from "react-i18next";

export default observer(function RemoveAllButton(props: {
	onCloseAll?: () => void;
}) {
	const { t } = useTranslation();

	if (!props.onCloseAll) {
		return null;
	}

	return (
		<div className="pagination__remove">
			<button
				className="pagination__remove__btn btn btn--sml btn--ghost--danger"
				type="button"
				onClick={props.onCloseAll}
			>
				{t<string>("COMMON.REMOVE_ALL")}
			</button>
		</div>
	);
});
